import type { ClassicProgress } from './classicDaily';

const ideas = [
  {
    title: 'Start with the nearly full unit',
    text: 'Look for a row, column or box with just one blank. Name the missing digit before widening your search.',
    href: '/sudoku-tips/#1-look-for-the-almost-full-row'
  },
  {
    title: 'Check three directions',
    text: 'A candidate must fit the row, column and box. If only one digit survives all three checks, you have a reason to place it.',
    href: '/sudoku-tips/#2-check-one-cell-in-three-directions'
  },
  {
    title: 'Give one number a home',
    text: 'Pick a missing digit in one row, column or box. Check every empty cell: if only one can hold it, that is its home.',
    href: '/sudoku-tips/#3-give-one-number-a-home'
  },
  {
    title: 'Let one placement lead to the next',
    text: 'After placing a digit, revisit its row, column and box. The new number may have removed a possibility somewhere nearby.',
    href: '/sudoku-tips/#when-nothing-stands-out'
  },
  {
    title: 'Give your notes a fresh check',
    text: 'Notes are possibilities, not promises. Recheck them against the current row, column and box; DaySudoku does not remove other cells\' notes automatically.',
    href: '/sudoku-notes/#a-quick-reset-when-notes-get-messy'
  },
  {
    title: 'Undo one step, not your whole solve',
    text: 'When something stops making sense, revisit your last uncertain entry. Undo can help you inspect one decision without starting over.',
    href: '/sudoku-mistakes/#3-undo-one-step-not-the-whole-puzzle'
  },
  {
    title: 'Keep a reason, not a race',
    text: 'On your next visit, aim for one placement you can explain. A slower solve with a clear deduction is still a good solve.',
    href: '/daily-sudoku-ritual/#curiosity-beats-speed'
  }
] as const;

export function getNextSolveIdea(phase: ClassicProgress['phase'] | 'loading', dailyDate: string) {
  if (phase !== 'full_done' || !/^\d{4}-\d{2}-\d{2}$/.test(dailyDate)) return null;
  const time = Date.parse(`${dailyDate}T00:00:00Z`);
  if (!Number.isFinite(time) || new Date(time).toISOString().slice(0, 10) !== dailyDate) return null;
  // Use the saved local play date, not the clock: midnight cannot change an open result's tip.
  const day = Math.floor(time / 86400000);
  return { ...ideas[((day % ideas.length) + ideas.length) % ideas.length] };
}
